import React, { useState, useEffect } from 'react';
import InputLabel from '../../../sharecomponents/InputLabel';
import CloseButton from '../../../sharecomponents/CloseButton';
import { activeDialog } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Post from '../../../../utils/Post copy';

const NuevoUsuarioForm = (p) => {
    const close = p.close ?? (() => { });
    const perfiles = p.perfiles ?? [];
    const getAPI = p.getAPI ?? (() => { });
    const ranchos = p.ranchos ?? [];
    const areas = p.areas ?? [];
    const [data, setdata] = useState({ name: '', password: '', type: '', rancho: '', area: '', ranchosHash: {}, areasHash: {} });
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='w-100 h-100 top-left-front bg-white3 blur-s'><div className='loader-local' /></div>);

    useEffect(() => {
        setdata({ name: '', password: '', type: '', rancho: '', area: '', ranchosHash: {}, areasHash: {} });
    }, [p.data])

    const change = (e) => {
        setdata({ ...data, [e.target.name]: e.target.value });
    }

    const agregarUsuario = async () => {
        const dtCopy = { ...data };
        dtCopy.ranchos = Object.keys(dtCopy.ranchosHash).map(k => +k);
        dtCopy.areas = Object.keys(dtCopy.areasHash).map(k => +k);
        let resp = await getAPI("secure/users/add", dtCopy);
        if (resp) {
            close(true);
        }
    }

    const ajustarHash = (tipo, valor) => {
        const id = valor.id;
        const dtCopy = { ...data };
        if (dtCopy[tipo][id]) {
            delete dtCopy[tipo][id];
        } else {
            dtCopy[tipo][id] = valor;
        }
        setdata(dtCopy);
        console.log(dtCopy);
    }

    return (
        <div className='w-100 h-100 blur-s bg-black4 p-2 contenedor round-s overflow' style={{ position: "fixed", top: 0, left: 0, zIndex: 10 }}>
            <CloseButton close={() => close(false)} floatElement={true} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-lg-12 mt-5 mb-5'></div>
                <div className='col-lg-12 mt-5 mb-5 p-5'></div>
                <div className='bw-500 shadow-multi round-s bg-white p-2'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 text-center text-l text-bold'>Agregar usuario</div>
                        <InputLabel label='Nombre (de 6 a 250 caracteres)' name='name' value={data.name} change={change} />
                        <InputLabel label='Contraseña (debe tener de 6 a 60 caracteres)' name='password' type='password' value={data.password} change={change} />

                        <div className='form-group bw-500 mt-2 mb-2'>
                            <label className='text-bold ps-2'>Selecione un tipo de perfil para el nuevo usuario</label>
                            <select className='form-control shadow-sm round-m' name='type' onChange={change} value={data.perfil}>
                                <option value='' >Todos los tipos</option>
                                {perfiles.map((perfil, i) => <option key={perfil + i} value={perfil.id} className='round-xxl mb-2' >{perfil.nombre}</option>)}
                            </select>
                        </div>
                        <div className='form-group bw-500 mt-2 mb-2 pb-3'>
                            <label className='text-bold ps-2'>Asigne Rancho(s) <span className="text-xs">Opcional</span></label>
                            <div className='row justify-content-between w-100 m-0 p-0'>
                                {ranchos.map((rancho, i) => <div key={rancho.nombre + i} className='form-check form-switch bw-200 border rounded '>
                                    <input className='form-check-input' type='checkbox' role='switch' id={rancho.nombre + i} checked={data.ranchosHash?.[rancho.id] ? true : false} onChange={() => ajustarHash('ranchosHash', rancho)} />
                                    <label className='form-check-label' htmlFor={rancho.nombre + i}>{rancho.nombre}</label>
                                </div>)}
                            </div>
                        </div>

                        <div className='form-group bw-500 mt-2 mb-2 pb-3'>
                            <label className='text-bold ps-2'>Asigne área(s) <span className="text-xs">Opcional</span></label>
                            <div className='row justify-content-between w-100 m-0 p-0'>
                                {areas.map((area, i) => <div key={area.nombre + i} className='form-check form-switch bw-200 border rounded '>
                                    <input className='form-check-input' type='checkbox' role='switch' id={area.nombre + i} checked={data.areasHash?.[area.id] ? true : false} onChange={() => ajustarHash('areasHash', area)} />
                                    <label className='form-check-label' htmlFor={area.nombre + i}>{area.nombre}</label>
                                </div>)}
                            </div>
                        </div>

                        <div className='form-group bw-500 mt-2 mb-2'>
                            <label className='text-bold ps-2'>Asigne un rancho <span className="text-xs">Opcional</span></label>
                            <select className='form-control shadow-sm round-m' name='rancho' onChange={change} value={data.rancho}>
                                <option value='' >Sin rancho</option>
                                {ranchos.map((rancho, i) => <option key={rancho.nombre + i} value={rancho.id} className='round-xxl mb-2' >{rancho.nombre}</option>)}
                            </select>
                        </div>
                        <div className='form-group bw-500 mt-2 mb-2'>
                            <label className='text-bold ps-2'>Asigne un área <span className="text-xs">Opcional</span></label>
                            <select className='form-control shadow-sm round-m' name='area' onChange={change} value={data.area}>
                                <option value='' >Sin área</option>
                                {areas.map((area, i) => <option key={area.nombre + i} value={area.id} className='round-xxl mb-2' >{area.nombre}</option>)}
                            </select>
                        </div>
                        <div className='w-100 text-center'>
                            <button className='btn btn-warning round-xxl mt-3 mb-4 shadow bw-400 text-bold' onClick={agregarUsuario}>Agregar usuario</button>
                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && ldr}
        </div>
    )
}

export default NuevoUsuarioForm;